// PreHarvestEvaluation.js

import { Grommet, Box, Text, Main, Footer, Button, CheckBox, Select, Layer, Heading, ResponsiveContext, TextInput, Card, Image } from "grommet";
import { Camera, Gallery } from "grommet-icons";
import {  useState, useEffect, useContext } from "react";
import { updateStateHandler, convertDateToDisplayformat, correctTimeZone, usePopupFocus } from "../Utils/Utils";
// import { useLocation } from "react-router-dom";
import { UserContext } from "../../App";

// column 1, 2
import {
    getPruningOptions,
    getFertilityOptions,
    getPathologyOptions,
    getColorUniformityOptions,
    getShotBerryOptions,
    getWaterBerryOptions,
    getBunchDensityOptions,
    getLabelByIndex,   
} from "../Utils/RBGUtils";

// column 3, 4
import {
    getRudimentOptions,
    getOverallAppealOptions,
    getSkinOptions,
    getBerryTextureOptions,
    getStemOptions,
    getSizeUniformityOptions,
} from "../Utils/RBGUtils";

// column 5, 6
import {
    getAcidAtEvalOptions,
    getAttachmentOptions,
    getAstringencyOptions,
    getFlavorOptions,
    getEatingQualityOptions,
    getSkinStructureOptions,
    getCapStemOptions,
    getBrushOptions,
} from "../Utils/RBGUtils";

import RadioWithText from "../Base components/RadioWithText";
// import InputWithText from "../Base components/InputWithText";
import InputWithFloatingLabel from "../Base components/InputWithFloatingLabel"
import BunchShapeChoice from "../Base components/BunchShapeChoice";
import BerryShapeChoice from "../Base components/BerryShapeChoice";

// column 7
import { Excel } from "grommet-icons";
import { getTreatmentPlanOptions } from "../Utils/RBGUtils";
import Notes from "../Base components/Notes";
// import BaseCamera from "../Base components/BaseCamera";
import ExcelExport from "../Base components/ExcelExport";
import Grade from "../Base components/Grade";
import ConfirmPopupWindow from "../Base components/ConfirmPopupWindow";
import ImageUpload from "../Base components/ImageUpload";


const customVineTheme = {
    global: {
        colors: {
            brand: '#3882b0',
            text: "#3882b0",
            border: "#3882b0",
            warn: '#ed9e15', // Custom color for checked state           
        },
        focus: {
            outline: {
                color: "#67b2e0",
            },
        },
    },
    radioButton: {
        border: {
            width: '2px',
            color: "#3882b0",
        },
        hover: {
            border: {
                color: "#045975",
            },
        },
        check: {
            radius: '100%',
            color: "#3882b0",
        },        
        // icon: {
        //     size: '14px', // affects the size of the inner circle
        // },        
        size: '20px', // affects the size of the outer circle 
        color: "#3882b0",
    },

    checkBox: {
        check: {
            //radius: '100%',
            extend: ({ checked }) => `
                // background-color: ${checked ? '#ed9e15' : '#3882b0'};
                border-color: ${checked ? '#ed9e15' : '#3882b0'};
                color: ${checked ? '#ed9e15' : '#3882b0'};
                // outline: 3px solid ${checked ? '#ffe6cc' : '#d3e6ed'};
            `,
        },

        hover: {
            border: {
                color: ({ checked }) => (checked ? '#ed9e15' : '#6faabf'),
            },
        },     

        icon: {
            color: 'customRed', // Color of the check mark when checked
            extend: ({ checked }) => `
                stroke: ${checked ? '#ed9e15' : '#0b7496'}; 
            `,
        },

        // Extend the style to apply focus outline conditionally
        extend: ({ checked }) => `
        input[type="checkbox"]:focus + div {
            outline: 3px solid ${checked ? '#ffe6cc' : '#d3e6ed'};
        }
        `,        
    },    
};

const customBunchTheme = {
    global: {
        colors: {
            brand: '#6c7bac',
            text: "#6c7bac",
            border: "#6c7bac",
            label: '#6c7bac',
        }, 
        focus: {
            outline: {
                color: "#b8c6f5",
            },
        }, 
    },
    radioButton: {
        border: {
            width: '2px',
            color: "#6c7bac",  
        },
        hover: {
            border: {
                color: "#2d4080",
            },
        },
        check: {
            radius: '100%',
            color: "#6c7bac",
        },                
        size: '20px', // affects the size of the outer circle 
        color: "#6c7bac",    
    },
    checkBox: {
        border: {
            width: '2px',
            color: "#6c7bac",  
        },
        hover: {
            border: {
                color: "#404967",
            },
        },
        check: {
            color: "#6c7bac",
        },                
        size: '20px', // affects the size of the outer circle 
        color: "#6c7bac",    
    },    
};

const customBerryTheme = {
    global: {
        colors: {
            brand: '#045d7d',
           text: "#045d7d",
           border: "#045d7d",
           label: '#045d7d',
            icon: "#00739D",         
        },
        focus: {
            outline: {
                color: "#9fbcc7",
            },
        }, 
    },
    radioButton: {
        border: {
            width: '2px',
            color: "#045d7d",  
        },
        hover: {
            border: {
                color: "#013345",
            },
        },  
        check: {
            radius: '100%',
            color: "#045d7d",
        },            
        size: '20px', // affects the size of the outer circle 
        color: "#045d7d",    
    },
    checkBox: {
        border: {
            width: '2px',
            color: "#045d7d",  
        },
        hover: {
            border: {
                color: "#013345",
            },
        },  
        check: {
            color: "#045d7d",
        },            
        size: '20px', // affects the size of the outer circle 
        color: "#045d7d",    
    }, 

};

const customSeededTheme = {
    global: {
        colors: {
          customRed: '#FF0000', // Custom color for checked state
          customBrand: '#045d7d', // Custom color for unchecked state
        },   
      },
    checkBox: {
        check: {
            //radius: '100%',
            extend: ({ checked }) => `
                // background-color: ${checked ? '#FF0000' : '#045d7d'};
                border-color: ${checked ? '#FF0000' : '#045d7d'};
                color: ${checked ? '#FF0000' : '#045d7d'};
                // outline: 3px solid ${checked ? '#facdcd' : '#d3e6ed'};
            `,
        },

        hover: {
            border: {
                color: ({ checked }) => (checked ? '#e39494' : '#6faabf'),
            },
        },     

        icon: {
            color: 'customRed', // Color of the check mark when checked
            extend: ({ checked }) => `
                stroke: ${checked ? '#FF0000' : '#0b7496'}; 
            `,
        },

        // Extend the style to apply focus outline conditionally
        extend: ({ checked }) => `
        input[type="checkbox"]:focus + div {
            outline: 3px solid ${checked ? '#facdcd' : '#d3e6ed'};
        }
        `,        

    },
};

const PreHarvestEvaluation = (props) => {
    // size of screen: small - mobile, medium ipad, large - computer
    //const size = useContext(ResponsiveContext);
    const currentUser = useContext(UserContext);

    // for the whole sheet
    let preHarvestValues = props.preHarvestValues;
    const setPreHarvestValues = props.setPreHarvestValues;
    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false); // Confirm Popup Window
    const [openUploadImageWindow, setOpenUploadImageWindow] = useState(false);  
    const [uploadParams, setUploadParams] = useState({});
 
    // Manage focus when opening modal windows
    usePopupFocus(confirmPopupOpen, "confirm-msg");  
    usePopupFocus(openUploadImageWindow, "upload-image");

    const handleOpenImageUpload = (params) => {
        setUploadParams(params);
        setOpenUploadImageWindow(true);
    };


    // console.log(" 🖖 props In PreHarvestEvaluation >> >>> ", props);

    useEffect(() => {
        if (props.disable) 
            return;        

        if (preHarvestValues.UpdatedAt && props.editMode) {
            setDisplayDate(convertDateToDisplayformat(preHarvestValues.UpdatedAt));         
        }

        // const start = Date.now();
        const interval = setInterval(() => {
            // console.log('saving !!! ', (interval) );           
            // const millis = Math.round((Date.now() - start)/1000);
            // console.log('interval: '+ millis + ' sec');
            if(props.editMode && props.hasEdit) {
                props.savePreharvesttHandler();
            }
            
        }, 3*60000);        // 180000 = 3 minute (3 * 60000 ms)
        // }, 10000);      // 10 sec
        return () => clearInterval(interval);

    }, [preHarvestValues]);

    // column 7  
    const [open, setOpen] = useState();
    const [msg, setMsg] = useState();
    const [init, setInit] = useState(false);
    

    const [displayDate, setDisplayDate] = useState('');
    
    // changing the location of the title on the screen resize
    const [top, setTop] = useState(
        {
            topMain:   
               (window.innerWidth < 291? '180px' :    
             //   window.innerWidth < 433 ? '225px' : 
                // window.innerWidth < 563 ? '230px' :                                
                window.innerWidth < 444 ? '155px' : '125px')                 
        }
    );

    useEffect(() => {
        function handleResize() {
            setTop({
                topMain:   
                   (window.innerWidth < 291? '180px' :    
                //    window.innerWidth < 433 ? '225px' : 
                    // window.innerWidth < 563 ? '230px' :                            
                    window.innerWidth < 444 ? '155px' : '125px')                                  
            })          
        }
        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    });

    // console.log('top >> ', top);
    const onOpen = () => setOpen(true);
    
    const onClose = () => {
        setOpen(undefined);
    };

    const calcTreatmentPlan = () => {       
        if (props.grade < 35) {   
            return 3;
        }
        if (props.grade < 80) {                
            return 2;
        }
        return 1;
    }

    useEffect(() => {
        // console.log("empty useeffect")
        if (props.grade < 35) {
            setMsg('You have chosen to disqualify this vine. The vine will be uprooted.');
            updateStateHandler(setPreHarvestValues,'TreatmentPlan',3);
        } 
        else if (props.grade < 80) {
            setMsg('You have chosen to reevaluate this vine. A new preHarvest evaluation sheet will now open to allow reevaluation.');
            updateStateHandler(setPreHarvestValues,'TreatmentPlan',2);
        } else {
            setMsg('You have chosen to mark this vine as excellent. A treatment sheet will now open to document the optimal treatment for this vine.');
            updateStateHandler(setPreHarvestValues,'TreatmentPlan',1);
        } 
    },[props.grade]);    
    
    const save = async () => {
        // console.log("in save func-n in PreHarvestEvaluation >> ");
        // console.log('preHarvestValues >> ', preHarvestValues);
        return (await props.savePreHarvestHandler());
    };

    useEffect(() => {
        if(init){
            const saveAndSetReturnToPrev = async () => {
                const result = await save();
                if (result) {
                    props.setSuccess(true);
                    props.setNavigateAfterSuccess(true);
                } else {
                    setInit(false);
                    props.setShowError(true); // optional: trigger error message
                }
            };

            saveAndSetReturnToPrev();
        }
             
    },[init]);

    // opens a popup window when the "submit" button is clicked
    const openConfirmPopupWindow = () => {
        setConfirmPopupOpen(true);
    }

    // hides the "Confirm" popup window 
    const onConfirmPopupClose = () => {
        setConfirmPopupOpen(false);    
    };

    // fires when the "Confirm" button is clicked in the "Yes" popup
    const onConfirmConfirm = () => {
        submit();
        onConfirmPopupClose();
    };
    
    const submit = async() => {  
        // console.log('in submit >> '); 
        // console.log('in submit StatusID >> ', preHarvestValues.StatusID); 
        // console.log('In savePreHarvestHandler preHarvestValues.preharvest_ID >> ', preHarvestValues.PreHarvestID); 
        if (preHarvestValues.StatusID !== 5) {
            updateStateHandler(setPreHarvestValues,'StatusID', 5);        
            updateStateHandler(setPreHarvestValues,'FinishedAt', correctTimeZone(new Date()));        
            updateStateHandler(setPreHarvestValues,'FinishedBy', currentUser.email);  
            updateStateHandler(setPreHarvestValues,'LastSyncDate', correctTimeZone(new Date()));       
        }       
        setInit(true);
    };

    // end of column 7

    const renderImageButton = ( imgExistProp, imgType) => {
        const hasImage = preHarvestValues[imgExistProp] === 1;
        // console.log('hasImage >>>   ', hasImage);
        const buttonStyle = {
            // background: hasImage ? 'white' : '#00739D',
            // border: hasImage ? '2px solid #00739D' : 'none',
            background: '#00739D',
            textAlign: 'center',
            padding: '5px',
            position: 'relative',
        };
        // const iconColor = hasImage ? '#00739D' : 'white';
        const iconColor = 'white';
        const IconComponent = hasImage ? Gallery : Camera;
        return (

            <Button
                style={buttonStyle}
                icon={
                    <Box>
                        <IconComponent color={iconColor} />
                      <Box
                        background={hasImage ? 'status-ok' : 'status-error'}
                        width="5px"
                        height="5px"
                        round
                        style={{
                          position: 'absolute',
                          top: '7px',
                          right: '7px',
                        }}
                      />
                    </Box>
                  }
                primary
                
                onClick={() => handleOpenImageUpload({
                    docType: "Evaluation",
                    docId: preHarvestValues.PreHarvestID,
                    imgType: imgType,
                    stateHandler: setPreHarvestValues,
                    initValue: preHarvestValues[imgExistProp], //props.preHarvestValues.BunchImgExist,
                    fieldName: imgExistProp,
                    tableName: "VEM_Evaluations",
                    disable: props.disable
                })}
            />
        );
      };

    const isSeeded = preHarvestValues.Seeded ? preHarvestValues.Seeded : false;
    const isRotten = preHarvestValues.Rotten ? preHarvestValues.Rotten : false;
    
    const title = props.plantInfo !==  null && props.plantInfo.IsSeedling === 1 ? 'PREHARVEST EVALUATION DATA' : 'TREATMENT EVALUATION DATA' ;
    const fruitColorLabel = getLabelByIndex(
        'FruitColor', 
        props.plantInfo ? props.plantInfo.FruitColor : props.station && props.station.FruitColor ? props.station.FruitColor : ''
    );

    //console.log('plant >> ', props.plantInfo);
    // console.log('displayDate >> ', displayDate);
    return (
        <ResponsiveContext.Consumer>
        {screenSize => (
        <Box>
            <Box align="center" background="brand"
                style={{ 
                    position: 'fixed',
                    width: '92%',       
                    zIndex: 10,
                    border: "5px solid white"
                }}            
            >
                <Box direction="row-responsive" justify="between"  align="end" margin="xxsmall" >
                    <Box >
                    <Text size="large" margin="xxsmall" textAlign="center" weight="bold"  color="white" >
                    {title}&emsp;&emsp;    
                    {displayDate !== "" && <span style={{whiteSpace: "nowrap", fontWeight: "normal", fontSize: "20px"}}><strong>({displayDate})</strong></span>}
                    </Text>
                    </Box>
                </Box>                               
            </Box>
            <Main 
                style={{ 
                position: 'absolute',
                height: '70%',
                top: top.topMain,
                width: '90%',
                }}
            >
            <Box direction="row-responsive" justify="center" width="100%"  wrap>
    
            {/* -------------------------------   column 1 ------------------------ */}
                <Box width="275px" margin="xxsmall">            
                    <Grommet theme={customVineTheme}>
                    <Box pad="small" background="transparent" border={{ size: 'xsmall' }} margin={{bottom: "5px"}}  height="670px" >
                        <Box margin={{vertical: "xxsmall"}}>
                            <Text color="brand"  alignSelf="center" size="20px">
                            Vine Characteristics:
                            </Text>
                            {/* <Text>{size}</Text> */}
                            <Box alignSelf="center" background="brand" height="2px" width="220px" margin={{vertical: "small"}}> </Box>
                        </Box>

                        <Box  alignContent="between" pad="small"  margin="xxsmall" >
                            <Text color="brand"  alignSelf="start" size="18px">
                                Fruit color:&nbsp;&nbsp;&nbsp;&nbsp;
                                {fruitColorLabel ? fruitColorLabel : 'unknown'}
                            </Text>
                        </Box>

                        <RadioWithText
                            text="Pruning:"
                            getOptions={getPruningOptions}
                            initValue={preHarvestValues.Pruning}//.hasOwnProperty('index')?preHarvestValues.Pruning.index:preHarvestValues.Pruning}
                            stateHandler={setPreHarvestValues}
                            fieldName="Pruning"
                            direction="column"
                            updateGrade={props.updateGrade}
                             disable={props.disable}
                        />

                        <RadioWithText
                            text="Fertility:"
                            getOptions={getFertilityOptions}
                            initValue={preHarvestValues.Fertility}
                            stateHandler={setPreHarvestValues}
                            fieldName="Fertility"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />

                        <RadioWithText
                            text="Pathology:"
                            getOptions={getPathologyOptions}
                            initValue={preHarvestValues.Pathology}
                            stateHandler={setPreHarvestValues}
                            fieldName="Pathology"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />

                        <Box direction="row"  height="50px"  align="center" >
                            <CheckBox pad={{horizontal: "10px"}}
                                checked={preHarvestValues.Rotten ? preHarvestValues.Rotten : false}
                                disabled={props.disable}
                                onChange={(event) => {
                                    updateStateHandler(
                                        setPreHarvestValues,
                                        "Rotten",
                                        event.target.checked
                                    );
                                }}
                            />
                            <Text
                                color={isRotten ? 'warn' : 'brand'}
                                style={{
                                    fontSize: isRotten ? '14px' : '18px', // Change font size if checked
                                    fontWeight: isRotten ? 'bold' : 'normal', // Optionally change font weight
                                }}
                                >
                                {isRotten ? 'Rotten before ripening'.toUpperCase() : 'Rotten before ripening'}
                            </Text>

                        </Box>     
                    </Box>
                    </Grommet>

                    <Grommet theme={customBunchTheme}>                  
                    <Box pad="small" background="transparent" border={{size: 'xsmall' }}  margin={{bottom: "5px"}} height="225px">
                        <Box margin={{vertical: "xxsmall"}}>
                            <Text color="brand" alignSelf="center"  size="20px">
                            Bunch Characteristics:
                            </Text>        
                            <Box alignSelf="center" background="#6c7bac" height="2px" width="220px" margin={{vertical: "xxsmall"}}> </Box>
                        </Box>
                        <Box >
                            <RadioWithText
                                text="Color Uniformity:"
                                getOptions={getColorUniformityOptions}
                                initValue={preHarvestValues.ColorUniformity}//.hasOwnProperty('index')?preHarvestValues.ColorUniformity.index:preHarvestValues.ColorUniformity}
                                stateHandler={setPreHarvestValues}
                                fieldName="ColorUniformity"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>

                    </Box>
                    </Grommet>
                </Box>
            {/* ---------------------------  end of column 1  --------------------- */}
            {/* -------------------------------   column 2 ------------------------ */}
                <Grommet theme={customBunchTheme}>
                <Box width="275px" margin="xxsmall">
                    <Box pad="small"  background="transparent"  border={{ size: 'xsmall' }} margin={{bottom: "10px"}}  height="900px">

                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                            text="Berry Size Uniformity:"
                            getOptions={getSizeUniformityOptions}
                            initValue={preHarvestValues.BerrySize}
                            stateHandler={setPreHarvestValues}
                            fieldName="BerrySize"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                            />
                        </Box>

                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Shot Berries:"
                                getOptions={getShotBerryOptions}
                                initValue={preHarvestValues.ShotBerries}//.hasOwnProperty('index')?preHarvestValues.ShotBerries.index:preHarvestValues.ShotBerries}
                                stateHandler={setPreHarvestValues}
                                fieldName="ShotBerries"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>
                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Water Berries:"
                                getOptions={getWaterBerryOptions}
                                initValue={preHarvestValues.WaterBerries}//.hasOwnProperty('index')?preHarvestValues.Fertility.index:preHarvestValues.Fertility}
                                stateHandler={setPreHarvestValues}
                                fieldName="WaterBerries"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>
                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Bunch Density:"
                                getOptions={getBunchDensityOptions}
                                initValue={preHarvestValues.BunchDensity}//.hasOwnProperty('index')?preHarvestValues.BunchDensity.index:preHarvestValues.BunchDensity}
                                stateHandler={setPreHarvestValues}
                                fieldName="BunchDensity"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>
                        <Box  margin={{vertical: "medium"}}>
                            <BunchShapeChoice
                                stateHandler={setPreHarvestValues}
                                preHarvestValues={preHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                disable={props.disable}
                                numOfColumns={2}
                            />
                        </Box>
                    </Box>
                </Box>
                </Grommet>
            {/* ---------------------------  end of column 2  --------------------- */}
            {/* -------------------------------   column 3 ------------------------ */}
                <Grommet theme={customBerryTheme}>
                <Box width="275px"  margin="xxsmall">
                    <Box pad="small" background="transparent" border={{ size: 'xsmall' }} margin={{bottom: "10px"}}  height="900px">
                        <Box margin={{vertical: "xxsmall"}}>       
                            <Text alignSelf="center" color="brand" size="20px">
                            Berry Characteristics:
                            </Text>
                            <Box alignSelf="center" background="brand" height="2px" width="220px" margin={{vertical: "small"}}> </Box>
                        </Box>                      

                        <Box margin={{top: "medium"}}>
                            <BerryShapeChoice 
                                stateHandler={setPreHarvestValues}
                                preHarvestValues={preHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                disable={props.disable}
                                numOfColumns={2}
                            />
                        </Box>

                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Skin Structure:"
                                getOptions={getSkinStructureOptions}
                                initValue={preHarvestValues.SkinStructure }
                                stateHandler={setPreHarvestValues}
                                fieldName="SkinStructure"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>

                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Stem:"
                                getOptions={getStemOptions}
                                initValue={preHarvestValues.Stem}
                                stateHandler={setPreHarvestValues}
                                fieldName="Stem"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>

                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Cap Stem:"
                                getOptions={getCapStemOptions}
                                initValue={preHarvestValues.CapStem }
                                stateHandler={setPreHarvestValues}
                                fieldName="CapStem"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>
                    </Box>  
                </Box> 
                </Grommet>           
            {/* ---------------------------  end of column 3  --------------------- */}
            {/* -------------------------------   column 4 ------------------------ */}
                <Grommet theme={customBerryTheme}>
                <Box width="275px" margin="xxsmall">                   

                    <Box pad="small" background="transparent" border={{size: 'xsmall' }} margin={{bottom: "10px"}} height="900px">

                    <Box margin={{vertical: "xsmall"}}>
                            <RadioWithText
                                text="Overall Appeal:"
                                getOptions={getOverallAppealOptions}
                                initValue={preHarvestValues.OverallAppeal}
                                stateHandler={setPreHarvestValues}
                                fieldName="OverallAppeal"
                                direction="column"
                                updateGrade={props.updateGrade}                   
                                disable={props.disable}
                            />
                        </Box>

                        <Box margin={{top: "small"}}>
                            <RadioWithText
                                text="Attachment:"
                                getOptions={getAttachmentOptions}
                                initValue={preHarvestValues.Attachment }
                                stateHandler={setPreHarvestValues}
                                fieldName="Attachment"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>

                        <Box margin={{vertical: "small"}}>
                            <RadioWithText
                                text="Brush:"
                                getOptions={getBrushOptions}
                                initValue={preHarvestValues.Brush }
                                stateHandler={setPreHarvestValues}
                                fieldName="Brush"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>


                        {props.station &&
                        <Box margin="small">        
                            <InputWithFloatingLabel style={{whiteSpace: 'pre-line'}}
                                text="TSS at Evaluation:"
                                subText="brix"
                                number={true}
                                initValue={preHarvestValues.TSSAtEval}
                                stateHandler={setPreHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="TSSAtEval"
                                disable={props.disable}

                             />   
                        </Box> 
                        }                             

                        <Grommet theme={customSeededTheme}>
                        <Box direction="row"  height="50px"  align="center" style={{margin: "0 0 0 10px"}}>
                            <CheckBox pad={{horizontal: "10px"}}
                                checked={preHarvestValues.Seeded ? preHarvestValues.Seeded : false}
                                disabled={props.disable}
                                onChange={(event) => {
                                    updateStateHandler(
                                        setPreHarvestValues,
                                        "Seeded",
                                        event.target.checked
                                    );
                                }}
                            />
                            <Text
                                color={isSeeded ? 'customRed' : 'customBrand'}
                                style={{
                                    fontSize: isSeeded ? '20px' : '18px', // Change font size if checked
                                    fontWeight: isSeeded ? 'bolder' : 'normal', // Optionally change font weight
                                }}
                                >
                                {isSeeded ? 'Seeded'.toUpperCase() : 'Seeded'}
                            </Text>

                        </Box>     
                        </Grommet>   
                        <Box margin={{vertical: "xsmall"}}>
                            <RadioWithText
                                text="Rudiment:"
                                getOptions={getRudimentOptions}
                                initValue={preHarvestValues.Rudiment}
                                stateHandler={setPreHarvestValues}
                                fieldName="Rudiment"
                                direction="column"
                                updateGrade={props.updateGrade}
                                disable={props.disable}
                            />
                        </Box>

                    </Box>
                </Box>
                </Grommet>
            {/* ---------------------------  end of column 4  -------------------- */}
            {/* -------------------------------   column 5 ----------------------- */}
            {/* <Box width={size === "small" ? "100%" : size === "medium" ? "30%" : "16%"} > */}
                <Grommet theme={customBerryTheme}>
                <Box width="275px" margin="xxsmall">
                    <Box pad="small" background="transparent" border={{ size: 'xsmall' }} margin={{bottom: "10px"}} height="900px">
                        <Box margin={{vertical: "xxsmall"}}>
                            <Text color="brand" alignSelf="center"  size="20px">
                            Taste:
                            </Text>        
                            <Box alignSelf="center" background="#6c7bac" height="2px" width="220px" margin={{vertical: "xxsmall"}}> </Box>
                        </Box>

                        <RadioWithText
                            text="Berry Texture:"
                            getOptions={getBerryTextureOptions}
                            initValue={preHarvestValues.BerryTexture}
                            stateHandler={setPreHarvestValues}
                            fieldName="BerryTexture"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />

                        <RadioWithText
                            text="Acidity at Evaluation:"
                            getOptions={getAcidAtEvalOptions}
                            initValue={preHarvestValues.AcidAtEval }
                            stateHandler={setPreHarvestValues}
                            fieldName="AcidAtEval"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />

                        <RadioWithText
                            text="Flavor:"
                            getOptions={getFlavorOptions}
                            initValue={preHarvestValues.Flavor }
                            stateHandler={setPreHarvestValues}
                            fieldName="Flavor"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />

                        <RadioWithText
                            text="Astringency:"
                            getOptions={getAstringencyOptions}
                            initValue={preHarvestValues.Astringency }
                            stateHandler={setPreHarvestValues}
                            fieldName="Astringency"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />                        

                        <RadioWithText
                            text="Skin:"
                            getOptions={getSkinOptions}
                            initValue={preHarvestValues.Skin}
                            stateHandler={setPreHarvestValues}
                            fieldName="Skin"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />

                    </Box>
                </Box>
                </Grommet>
            {/* ---------------------------  end of column 5  -------------------- */}
            {/* -------------------------------   column 6 ----------------------- */}
            {/* <Box width={size === "small" ? "100%" : size === "medium" ? "30%" : "16%"} > */}
                <Grommet theme={customBerryTheme}>
                <Box  width="275px" margin="xxsmall">
                    <Box pad="small" background="transparent" border={{ size: 'xsmall' }} margin={{bottom: "10px"}} height="900px">
                       
                        <RadioWithText
                            text="Eating Quality:"
                            getOptions={getEatingQualityOptions}
                            initValue={preHarvestValues.EatingQuality }
                            stateHandler={setPreHarvestValues}
                            fieldName="EatingQuality"
                            direction="column"
                            updateGrade={props.updateGrade}
                            disable={props.disable}
                        />
                   
                        {props.station &&
                        <Box margin="50px 0 0 0">       
                            <Text alignSelf="center" color="brand" size="20px">
                            Lab Measurements:
                            </Text>
                            <Box alignSelf="center" background="brand" height="2px" width="220px" margin={{vertical: "small"}}> </Box>
                        </Box>
                        }
                        
                        {props.station &&
                        <Box margin="small">        
                            <InputWithFloatingLabel style={{whiteSpace: 'pre-line'}}
                                text="TSS at Ripeness:"
                                subText="brix"
                                number={true}
                                initValue={preHarvestValues.TSSAtRipeness}
                                stateHandler={setPreHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="TSSAtRipeness"
                                disable={props.disable}

                             />   
                        </Box> 
                        }  

                        {props.station &&
                        <Box margin="small">
                            <InputWithFloatingLabel
                            text="pH at Ripeness"
                            subText=""
                            number={true}
                            initValue={preHarvestValues.PHAtRipeness}
                            stateHandler={setPreHarvestValues}
                            updateProgressByCheck={props.updateProgressByCheck}
                            fieldName="PHAtRipeness"
                            disable={props.disable}
                            />
                        </Box> 
                        }

                        {props.station &&
                        <Box margin="small">
                            <InputWithFloatingLabel
                            text="TA at Ripeness"
                            subText=""
                            number={true}
                            initValue={preHarvestValues.TAAtRipeness}
                            stateHandler={setPreHarvestValues}
                            updateProgressByCheck={props.updateProgressByCheck}
                            fieldName="TAAtRipeness"
                            disable={props.disable}
                            />
                        </Box>                        
                        }
                        {props.station &&
                        <Box margin="small">        
                            <InputWithFloatingLabel style={{whiteSpace: 'pre-line'}}
                                text="Avg Berry Weight (20-berries)"
                                subText="gr"
                                number={true}
                                initValue={preHarvestValues.AvgBerryWeight}
                                stateHandler={setPreHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="AvgBerryWeight"
                                disable={props.disable}
                            />
                        </Box>                        
                        }
                        {props.station &&
                        <Box margin="small">        
                            <InputWithFloatingLabel style={{whiteSpace: 'pre-line'}}
                                text="Avg Berry Diameter"
                                subText="mm"
                                number={true}
                                initValue={preHarvestValues.AvgBerryDiameter}
                                stateHandler={setPreHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="AvgBerryDiameter"
                                disable={props.disable}
                            />
                        </Box>
                        }
                        {props.station &&
                        <Box margin="small">        
                            <InputWithFloatingLabel style={{whiteSpace: 'pre-line'}}
                                text="Avg Berry Area"
                                subText="mm&sup2;" // Display mm² as square millimeters
                                number={true}
                                initValue={preHarvestValues.AvgBerryArea}
                                stateHandler={setPreHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="AvgBerryArea"
                                disable={props.disable}
                            />
                        </Box>
                        }
                        {props.station &&
                        <Box margin="small">        
                            <InputWithFloatingLabel style={{whiteSpace: 'pre-line'}}
                                text="Firmness"
                                subText="N"
                                number={true}
                                initValue={preHarvestValues.AvgBerryFirmness}
                                stateHandler={setPreHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="AvgBerryFirmness"
                                disable={props.disable}
                            />
                        </Box>
                        }



                        {props.plantInfo &&
                        <Box margin={{ top: 'xlarge', bottom: 'small', left: 'small', right: 'small' }} >        
                            <Image
                                size="contain"
                                src="Seedling.png"
                                opacity="medium"
                                margin={{ top: 'small' }}  // Add margin to the image                                    
                            />
                        </Box>
                        }   






                    </Box>
                </Box>
                </Grommet>
            {/* ---------------------------  end of column 6---------------------- */}
            {/* -------------------------------   column 7 ----------------------- */}
                <Box  width="100%"  >
                    <Box pad="small" background="transparent" border={{ size: 'xsmall' }} margin={{bottom: "5px"}}>
                        <Box direction="row-responsive"  justify="between" wrap>
                            <Box width="540px" height="200px">
                                <Notes
                                    stateHandler={setPreHarvestValues}
                                    disable={props.disable}
                                    initValue={preHarvestValues.Notes}
                                    fieldName="Notes"
                                />
                            </Box>
                            <Box direction="column"  width="270px" pad="xsmall" >
                                {openUploadImageWindow && 
                                <Box>
                                    <ImageUpload 
                                        onClose={setOpenUploadImageWindow} 
                                        {...uploadParams}                           
                                    />
                                </Box>}

                                 <Box align="end" width="246px" direction="row">
                                <Text style={{ padding: "5px 0 ", margin: "5px 0 0 0", fontSize: "large", width: "215px"}}>Bunch</Text>                               
                                 {renderImageButton( 'BunchImgExist', 'Bunch')}
                                </Box> 

                                <Box align="end" width="246px" direction="row">
                                <Text style={{ padding: "5px 0 ", margin: "5px 0 0 0", fontSize: "large", width: "215px"}}>Berry</Text>                               
                                 {renderImageButton( 'BerryImgExist', 'Berry')}
                                </Box> 


                                {/* <Box align="center" width="246px" direction="row">
                                <Text style={{ padding: "5px 0 ", margin: "5px 0 0 0", fontSize: "large", width: "215px"}}>Halved Berry</Text>                               
                                <Button
                                    style={{ color: "#ffffff", textAlign: "center", padding: "6px" }}
                                    icon={
                                        props.preHarvestValues.HalvedBerryImgExist === 1 ? (
                                          <Gallery color="white" />
                                        ) : (
                                          <Camera color="white" />
                                        )
                                    }
                                    primary
                                    onClick={() => handleOpenImageUpload({
                                        docType: "Evaluation",
                                        docId: preHarvestValues.PreHarvestID,
                                        imgType: "HalvedBerry",
                                        stateHandler: setPreHarvestValues,
                                        initValue: props.preHarvestValues.HalvedBerryImgExist,
                                        fieldName: "HalvedBerryImgExist",
                                        tableName: "VEM_Evaluations",
                                        disable: props.disable
                                    })}
                                 />
                                </Box>  */}

                                <Box align="end" width="246px" direction="row">
                                <Text style={{ padding: "5px 0 ", margin: "5px 0 0 0", fontSize: "large", width: "215px"}}>Halved Berry</Text>                               
                                 {renderImageButton( 'HalvedBerryImgExist','HalvedBerry')}
                                </Box> 

                                <Box align="center" direction="row" width="246px">
                                    <TextInput
                                        style={{ padding: "5px 0 ", margin: "5px 0 0 0", fontSize: "large", width: "110px"}}
                                        value={preHarvestValues.FreeImgText === null ? "" : preHarvestValues.FreeImgText}
                                        plain="full"
                                        placeholder="Free text.."
                                        onChange={(event) => {
                                            updateStateHandler(setPreHarvestValues, "FreeImgText", event.target.value);
                                        }}    
                                        readOnly={props.disable}                                                                                                                           
                                    />
                                    {/* <Button
                                        style={{ color: "#ffffff", textAlign: "center", padding: "6px" }}
                                        icon={
                                            props.preHarvestValues.FreeImgExist === 1 ? (
                                              <Gallery color="white" />
                                            ) : (
                                              <Camera color="white" />
                                            )
                                        }
                                        primary
                                        onClick={() => handleOpenImageUpload({
                                            docType: "Evaluation",
                                            docId: preHarvestValues.PreHarvestID,
                                            imgType: "Free",
                                            stateHandler: setPreHarvestValues,
                                            initValue: props.preHarvestValues.FreeImgExist,
                                            fieldName: "FreeImgExist",
                                            tableName: "VEM_Evaluations",
                                            disable: props.disable
                                        })}
                                    /> */}
                                 {renderImageButton( 'FreeImgExist', 'Free')}
                                </Box>

                                {preHarvestValues.Seeded && (
                                <Box alignSelf="start">
                                    <Text alignSelf="center" color="red" size="large" bold>
                                    <strong> This Evaluation Is Seeded!</strong>
                                    </Text>
                                </Box>
                                )}           
                            </Box>
                            <Box width="200px" style={{fontWeight: "bolder"}} margin={{vertical: "small"}}>
                                <Card 
                                    background={(props.grade < 35) ? "orange" : (props.grade < 80 ? "lightyellow" : "lightgreen")}
                                    pad="xsmall"  
                                    style={{
                                        height: "100px",
                                        padding: "10px, auto",
                                        boxShadow: "5px 10px 8px #888888",
                                    }} 
                                    border={{color: "brand", size: "medium"}}>
                                        <Text color="brand" size="large"> Decision: <span style={{whiteSpace: 'pre-line', fontSize: '26px'}}>{getLabelByIndex ('TreatmentPlan', preHarvestValues.TreatmentPlan === null ? 3 : preHarvestValues.TreatmentPlan)}</span></Text>
                                </Card>                                
                            </Box>
                            <Box alignSelf="start" style={{fontWeight: "bolder"}}>
                                <Grade 
                                    grade={props.grade}  
                                    eliminateRange={{min: 0, max: 34}} 
                                    secondChanceRange={{min: 35, max: 79}}
                                    commercialPointsRange={{min: 80, max: 100}}>
                                </Grade>
                            </Box>

                        </Box>
                    </Box>
                </Box>
                {/* the popup window should be opened when choosing a treatment plan, 
                    but now it does not opened because the logic has been changed  */}
                {open && (
                <Layer
                    id="hello world"
                    position="center"
                    onClickOutside={onClose}
                    onEsc={onClose}
                >
                    <Box pad="medium" gap="small" width="medium">
                        <Heading level={3} margin="none">
                        Decision
                        </Heading>
                        <Text>{msg}</Text>
                        <Box
                            as="footer"
                            gap="small"
                            direction="row"
                            align="center"
                            justify="end"
                            pad={{ top: 'medium', bottom: 'small' }}
                        >
                            <Button
                                label={
                                    <Text color="white">
                                    <strong>Confirm</strong>
                                    </Text>
                                }
                            onClick={submit}
                            primary
                            />
                        </Box>
                    </Box>
                </Layer>
                )} 

            {/* ---------------------------  end of column 7  -------------------- */}
            </Box>

            {confirmPopupOpen && (
                <ConfirmPopupWindow
                    msg={
                        "This evaluation will be finished! Are you sure you want to continue?"
                    }
                    onClose={onConfirmPopupClose}
                    onConfirm={onConfirmConfirm}
                />
            )}
            </Main>
            <Footer pad="medium" direction="row-responsive" justify="center"
                style={{ 
                position: 'fixed',
                width: '90%',
                bottom: '9%',
                }}
            >
                <Box >
                    <Button
                        style={{
                            width: "170px",
                            margin: "0 auto",
                            background: "#039039",
                            border: "1px solid #039039",
                            // fontWeight: 600,
                        }}
                        label="Submit"
                        disabled={props.disable || preHarvestValues.StatusID === 5} onClick={openConfirmPopupWindow} />
                </Box>
                <Box justify="center" >
                    <Button style={{width: "170px", margin: "0 auto"}} 
                    label="Save Draft"
                    disabled={props.disable} onClick={save} primary />
                </Box>
           </Footer>
        </Box> 
      )}

      </ResponsiveContext.Consumer>

  );
};

export default PreHarvestEvaluation;
